<style>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	    -webkit-appearance: none;
	    appearance: none;
	    margin: 0;
	}
	.el-form-item__label{
		text-align: left;
	}
	.el-form-item__content{
		text-align: left;
	}
	.inp{
		width: 55%;
	}
</style>
<template>
	<div class="index">
		<!--头部-->
		<HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
		<HeaderView @showLoginPop="showLoginPopFn" @serchMsg="serchMsg($event)" ref="child"></HeaderView>
		<NavView></NavView>
		<!--内容-->
		<div class="content">
			<div class="content_top">
				<div class="background"></div>
				<div class=" content_div">
					<!-- 左侧图片 -->
					<div class="product_img">
						<div class="product_this">
							<img :src="image ? $img+image : ''" alt="">
						</div>
						<div class="swiper-container gallery_top">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(liem,index) in imgArr" :key="index" @click="tab_img(liem)" :style="{backgroundImage: 'url(' + ($img+liem) + ')'}"></div>
							</div>
							<!-- Add Arrows -->
							<div class="swiper-button-next swiper-button-white"></div>
							<div class="swiper-button-prev swiper-button-white"></div>
						</div>
					</div>
					<!-- 右侧文字 -->
					<div class="product_parameter">
						<div>
							<div class="Title">
								<div class="Title_box">
									<span class="Title_text">{{products.productNum}}</span>
									<span class="brief" style="color: #cd652c;">{{$t('product.startBuy') + (products.startBuy ? products.startBuy : 1)}}</span>
									<span class="money">{{$type == 1?'￥':'$'}}{{products.unitPrice ? (products.unitPrice / 100).toFixed(2) : 0}}<span v-if="money"> ≈ ￥{{money}}</span>
									</span>
								</div>
								<div class="Title_box">
									<span class="brief">{{products.productDescribe}}</span>
									<!-- <el-button type="primary" size="medium" @click="see">{{$t('shopDet.see')}}</el-button> -->
								</div>
								<div class="Title_box-mine">
									<div style="color:#cd652c;margin-bottom: 10px;">{{$t('product.goodsLoop') + '：' + (products.goodsLoop || '')}}</div>
									<div class="price-index-items" v-for="item in products.$priceIndex">
										<p>{{$t('product.buy') + item.num}}</p>
										<p>{{$t('product.unitPrice') + `：${$type == 1?'￥':'$'}` + item.price / 100}}</p>
									</div>
								</div>
							</div>
							<div class="configure_BOX">
								<span class="configure">{{$t('shopDet.application')}}</span>
								<div class="selection">
									<ul>
										<li v-for="(item,index) in detArr" :key="index" v-if="item.columnType == 0">{{item.title}}:{{item.txt}}</li>
									</ul>
									<div></div>
								</div>
							</div>
							<div class="f20 mt20">
								{{$t('shopDet.Purchasequantity')}}：<el-input-number v-model="number" @change="handleChange" :min="+products.startBuy"
								 label="描述文字"></el-input-number>
							</div>
						</div>

						<div class="Shopping">
							<button class="purchase" @click="settlementToPay(products.productId)">{{$t('shopDet.purchase')}}</button>
							<button class="join" @click="addtocart">{{$t('shopDet.shoppingCart')}}</button>
							<button class="Apply" @click="getsample">
								{{$t('shopDet.sample')}}
								<p>({{$t('shopDet.consume')}}{{products.customIntegration}}{{$t('shopDet.integral')}})</p>
							</button>
						</div>
					</div>
				</div>
				<!-- 收藏 -->
				<div class="Collection">
					<div @click="collection" class="flex_between">
						<img src="../../assets/images/collection.png" alt=""><span>{{$t('shopDet.Collection')}}</span>
					</div>
				</div>
			</div>
			<section class="word section-content">
				<div class="detailed_box">
					<!-- 产品描述 -->
					<div class="necessary">
						<div class="describe" v-for="(item,index) in detArr" :key="index" v-if="item.columnType == 1">
							<div class="icon">
								<div class="icon_box">
									<img src="../../assets/images/necessary.png" alt="">
									<span>{{item.title}}</span>
								</div>
							</div>
							<div class="describe_text" v-if="item.type == 'text' && item.txt">
								{{item.txt}}
							</div>
							<div class="describe_text" v-if="!item.txt">
								{{$t('placeorder.Nodata')}}
							</div>
							<div class="describe_text" v-if="item.type == 'image' && item.txt" v-for="(items,indes) in item.txt" :key="indes">
								<img :src="$img+items" alt="">
							</div>
							<div class="describe_text" v-if="item.type == 'word' && item.txt">
								<el-table :data="item.txt" style="width: 100%" width="200">
									<el-table-column prop="name" :label="$t('shopDet.Documentname')" width="200" align="center">
									</el-table-column>
									<el-table-column prop="desc" :label="$t('shopDet.description')" width="200" align="center">
									</el-table-column>
									<el-table-column prop="size" :label="$t('shopDet.size')" width="200" align="center">
									</el-table-column>
									<el-table-column prop="time" :label="$t('shopDet.time')" width="200" align="center">
									</el-table-column>
									<el-table-column prop="url" :label="$t('shopDet.download')" width="200" align="center">
										<template slot-scope="scope">
											<a :href="$img+scope.row.url" download>
												<el-button size="mini" type="primary"><i class="el-icon-bottom el-icon--right"></i></el-button>
											</a>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>
				</div>
			</section>
		  <section  class="word section-content" style="text-align: left;padding-top:0;">
        <div v-html="products.richText"></div>
      </section>
    </div>
		<el-dialog :title="$t('shopDet.sample')" :visible.sync="dialogVisible" width="35%" @close="close">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" size="mini">
				<el-form-item :label="$t('shopDet.consignee')" prop="consignee" label-width="100px">
					<el-input v-model="ruleForm.consignee" class="inp"></el-input>
				</el-form-item>
				<el-form-item :label="$t('shopDet.tel')" prop="tel" label-width="100px">
					<el-input v-model="ruleForm.tel" class="inp" type="number"></el-input>
				</el-form-item>
				<el-form-item :label="$t('shopDet.address')" prop="city" label-width="100px">
					<el-input v-model="ruleForm.city" class="inp"></el-input>
				</el-form-item>
				<!-- <el-form-item label="您的职业" prop="region" label-width="200px" class="label">
					<el-select v-model="ruleForm.region" placeholder="请选择活动区域">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="您的设计所处阶段" prop="region" label-width="200px">
					<el-select v-model="ruleForm.region" placeholder="请选择活动区域">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="预计投入生产时间" prop="region" label-width="200px">
					<el-select v-model="ruleForm.region" placeholder="请选择活动区域">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="您每年的用量大约多少" prop="region" label-width="200px">
					<el-select v-model="ruleForm.region" placeholder="请选择活动区域">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="器件最终用途的应用领域" prop="region" label-width="200px">
					<el-select v-model="ruleForm.region" placeholder="请选择活动区域">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户类型" prop="resource" label-width="100px">
					<el-radio-group v-model="ruleForm.resource">
						<el-radio label="线上品牌商赞助"></el-radio>
						<el-radio label="线下场地免费"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="您要购买的器件是用于核设施、导弹、军事、和化学生物应用吗？" prop="resource" label-width="450px">
					<el-radio-group v-model="ruleForm.resource">
						<el-radio label="是"></el-radio>
						<el-radio label="否"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="您的产品是否不投入应用，而是在出口至其他国家或地区?" prop="resource" label-width="450px">
					<el-radio-group v-model="ruleForm.resource">
						<el-radio label="是"></el-radio>
						<el-radio label="否"></el-radio>
					</el-radio-group>
				</el-form-item> -->
				<el-form-item class="ml10">
					<el-button type="primary" @click="submitForm('ruleForm')">{{$t('shopDet.apply')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 登录弹窗 -->
		<LoginPop v-if="popShow" @closePop="closePopFn" @register="register"></LoginPop>
		<!-- 底部 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import HeaderView from "@/components/assembly/Header.vue"; //头部模块
	import NavView from "@/components/assembly/Nav.vue"; //导航模块
	import Footer from "@/components/assembly/Footer.vue"; //导航模块
	import LoginPop from "@/components/assembly/LoginPop.vue"; //登录弹窗
	import "@/assets/js/swiper.animate1.0.3.min.js";
	import "@/assets/css/animate.min.css";
	export default {
		name: "productSearch",
		data() {
			return {
				detArr: [],
				image: "",
				number: 1,
				money: "",
				num: '1',
				popShow: false,
				products: {},
				searchMsg: '',
				token: '',
				id: "",
				dialogVisible: false,
				ruleForm: {
					consignee: '',
					tel: '',
					city: '',
					region: '',
					resource: ''
				},
				rules: {},
				imgArr: []
			}
		},
		components: {
			HeaderView,
			NavView,
			HeaderTopView,
			Footer,
			LoginPop
		},
		mounted() {
			this.rules = this.$t('shopDet.rules')
			this.id = this.$route.query.id
			this.getProducts();
			if (sessionStorage.getItem('token')) {
				this.getFootprint()
			}
		},
		methods: {
			handleEdit(index, row) {

			},
			// 申请样品
			getsample() {
				if (sessionStorage.getItem('token')) {
					this.dialogVisible = true
				} else {
					this.$showNotFoundLoginComponent()
				}
			},
			// 获取参数列
			getColumn() {
				let url = `/open/product/column?catalogId=${this.products.catalogId}`
				this.$get(url).then(res => {
					if (res.code == 0) {
						for (let i in this.products.product) {
							res.data.map(item => {
								if (item.columnId == i.slice(6)) {
									if (item.columnComment == 'word') {
										this.products.product[i] = this.products.product[i] ? JSON.parse(this.products.product[i]) : this.products
											.product[i]
									}
									this.detArr.push({
										title: item.columnName,
										type: item.columnComment,
										txt: item.columnComment == 'image' ? this.products.product[i].split(',') : this.products.product[i],
										columnType: item.columnType,
										sort: item.sort
									})
									this.detArr.sort((a, b) => a.sort - b.sort)
								}
							})
						}
					}
				})
			},
			// 切换大图
			tab_img(e) {
				this.image = e
			},
			// 数量加减
			handleChange(value) {
				this.number = value
			},
			// 查看人民币价格
			see() {
				let url = '/open/product/get/usd/price'
				this.$get(url, {
					unitPrice: this.products.unitPrice / 100
				}).then(res => {
					if (res.code == 0) {
						this.money = res.data
					}
				})
			},
			// 关闭弹框
			close() {
				this.ruleForm.tel = ''
				this.ruleForm.city = ''
				this.ruleForm.consignee = ''
			},
			// 申请样品
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let url = '/api/order/add/order'
						let data = {
							token: sessionStorage.getItem('token'),
							productId: this.$route.query.id,
							integralNum: this.products.customIntegration,
							receivingAddress: this.ruleForm.city,
							receivingPhone: this.ruleForm.tel,
							receivingUser: this.ruleForm.consignee
						}
						this.$post(url, data).then(res => {
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.applysuc'),
									type: 'success'
								});
								this.dialogVisible = false
							}
						})
					} else {
						return false;
					}
				});
			},
			// 新增足迹
			getFootprint() {
				let url = '/api/footprint/addFootprint'
				let data = {
					token: sessionStorage.getItem('token'),
					productId: this.$route.query.id
				}
				this.$post(url, data).then(res => {

				})
			},
			// 立即购买
			settlementToPay(carIds) {
				//跳转提交订单页面
				if (sessionStorage.getItem('token')) {
					var y = String(this.number).indexOf(".") + 1; //获取小数点的位置
					var count = String(this.number).length - y; //获取小数点后的个数
					if (y > 0) {
						this.$message({
							message: this.$t('Tips.num'),
							type: 'warning'
						});
						return false
					}
					this.$router.push({
						path: '/submit/order',
						query: {
							carIds,
							num: 1,
							number: this.number
						}
					});
				} else {
					this.$showNotFoundLoginComponent()
				}
			},
			collection() {
				let url = '/api/productCollection/addProductCollection'
				let data = {
					productId: this.products.productId,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.$message({
							showClose: true,
							message: this.$t('Tips.collectionsuc'),
							type: 'success'
						});
					}

				})
			},
			addtocart() {
				let url = '/api/shop/car/add'
				let data = {
					producNum: this.number,
					productId: this.products.productId,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.$message({
							showClose: true,
							message: this.$t('Tips.addsuc'),
							type: 'success'
						});
						this.$refs.child.getShopnum()
					}

				})
			},
			swiperFun() {
				//加载swiper
				var galleryTop = new Swiper(".gallery_top", {
					nextButton: ".swiper-button-next",
					prevButton: ".swiper-button-prev",
					paginationClickable: true,
					slidesPerView: 4,
					spaceBetween: 10,
					observer: true,
				});
			},
			parentFn(payload) {
				console.log("登录" + payload);
			},
			showLoginPopFn(i) {
				this.popShow = i;
			},
			closePopFn(i) {
				this.popShow = !i;
			},
			register() {
				this.$router.push("/register");
			},
			serchMsg(e) {

			},
			/*获取搜索产品*/
			getProducts() {
				let that = this
				let url = "/open/product/getProduct";
				this.token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '1';
				let data = {
					productId: this.$route.query.id,
					token: this.token,
					language: localStorage.getItem('lang')
				};
				this.$get(url, data).then(res => {
					if (res.code == 0) {
						if (res.data.productImg) {
							this.imgArr = res.data.productImg.split(',')
							this.image = this.imgArr[0]
							this.$nextTick(() => {
								this.swiperFun();
							});
						}
						let data = res.data;
						if (data.priceIndex && data.priceIndex !== 'null') {
							let temp = JSON.parse(data.priceIndex);
							temp.sort((a, b) => a.num - b.num);
							data.$priceIndex = temp;
						} else {
							data.$priceIndex = [];
						}
						this.number = data.startBuy;
						this.products = data;
						this.getColumn()
					}
				})
			}
		},
	}
</script>

<style scoped>
	.mt20 {
		margin-top: 20px;
	}

	.ml10 {
		margin-left: 10px;
	}

	.f20 {
		font-size: 20px
	}

	/* 中间swiper */
	.swiper-wrapper {
		width: 100%;
		height: 100px;
	}

	.swiper-container {
		width: calc(100% - 80px) !important;
		margin: 0 !important;
	}

	.banner_swiper .gallery_top {
		width: 100%;
		height: 80px;
	}

	.banner_swiper .gallery_thumbs {
		width: 190px;
		height: 100%;
	}

	.banner_swiper .swiper-button-white {
		width: 30px;
		height: 60px;
		background-color: rgba(0, 0, 0, 0.2);
		background-size: 20px;
	}

	.swiper-slide {
		background-size: 100% 100%;
		/* width: 25% !important; */
	}

	.banner_swiper .swiper-pagination {
		width: auto;
		left: 37px;
	}

	.banner_swiper .swiper-pagination .swiper-pagination-bullet {
		width: 10px;
		height: 10px;
		opacity: 0.4;
		border-right: 50%;
		margin-right: 10px;
		margin-left: 0;
	}

	.banner_swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
		width: 10px;
		height: 10px;
		background: #fff;
		opacity: 1;
		border-right: 50%;
	}

	.content .word .detailed_box .necessary .Characteristic .icon {
		display: flex;
		background-color: #F6F6F6;
	}

	.content .word .detailed_box .necessary .Characteristic .icon .icon_box>span {
		position: absolute;
		margin: 0 auto;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		line-height: 35px;
		color: #FFFFFF;
		font-size: 20px;
	}

	.content .word .detailed_box .necessary .Characteristic .icon .icon_box>img {
		width: 100%;
	}

	.content .word .detailed_box .necessary .Characteristic .icon .icon_box {
		position: relative;
		height: 35px;
		width: 174px;
	}

	.detailed_box .necessary .describe .describe_text {
		color: #666666;
		font-size: 16px;
		padding: 30px 40px;
		line-height: 20px;
		letter-spacing: 1px;
		text-align: left;
		border: 1px solid rgba(226, 226, 226, 1);
	}

	.describe_text img {
		width: 95%;
		margin: 0 auto;
	}

	.detailed_box .necessary .describe .icon .name {
		flex: 1;

		color: #333333;
		line-height: 35px;
		text-align: left;
		padding-left: 20px;
		font-size: 14px;
	}

	.detailed_box .necessary .describe .icon .icon_box>span {
		position: absolute;
		margin: 0 auto;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		line-height: 35px;
		color: #FFFFFF;
		font-size: 20px;
	}

	.content .word .detailed_box .necessary .describe .icon .icon_box {
		position: relative;
		height: 35px;
	}

	.content .word .detailed_box .necessary .describe .icon {
		display: flex;
		background-color: #F6F6F6;
	}

	.content .word .detailed_box .necessary .Characteristic {
		width: 468px;
		height: 485px;
		border: 1px solid rgba(226, 226, 226, 1);
	}

	.content .word .detailed_box .necessary .describe {
		width: 100%;
		/* height: 485px; */
		margin-bottom: 50px;
	}

	/* 	.content .word .detailed_box .necessary {
		display: flex;
		justify-content: space-between;
	} */

	.content .word {
		padding: 40px 36px;
	}

	.content .content_top .Collection {
		display: flex;
		max-width: 1200px;
		min-width: 1200px;
		margin: 0 auto;
		padding: 20px 0;
	}

	.content .content_top .Collection>span {
		color: #4A4A4A;
		height: 20px;
		line-height: 20px;
		margin-left: 6px;
	}

	.content .content_top .Collection>img {
		width: 20px;
		height: 20px;
	}

	.content_div .product_parameter .Shopping {
		margin-top: 31px;
	}

	.content_div .product_parameter .Shopping .Apply {
		border: 1px solid #F48655;
		color: #F48655;
		height: 60px;
		line-height: 20px;
		text-align: center;
		background-color: #FDEEE7;
		width: 150px;
	}

	.content_div .product_parameter .Shopping .join {
		border: 1px solid #117BD0;
		background-color: #ECF5FB;
		color: #117BD0;
		width: 138px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		margin-right: 10px;
	}

	.content_div .product_parameter .Shopping {
		display: flex;
		margin-bottom: 20px;
	}

	.content_div .product_parameter .Shopping .purchase {
		background: -webkit-linear-gradient(#3899E6, #0E79CF);
		/* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(#3899E6, #0E79CF);
		/* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(#3899E6, #0E79CF);
		/* Firefox 3.6 - 15 */
		background: linear-gradient(#3899E6, #0E79CF);
		/* 标准的语法 */
		color: #FFFFFF;
		width: 253px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		margin-right: 10px;
	}

	.content_div .product_parameter .configure_BOX .selection>ul>li {
		width: 50%;
		text-align: left;
		color: #666666;
		height: 50px;
		line-height: 50px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		font-size: 15px;

	}

	.content_div .product_parameter .configure_BOX .selection>ul {
		display: flex;
		flex-wrap: wrap;
		border-bottom: 1px solid #E2E2E2;
		padding-bottom: 15px;
		max-height: 216px;
		overflow-y: auto;

	}

	.content_div .product_parameter .configure_BOX .configure {
		display: block;
		color: #C2652C;
		text-align: left;
		font-size: 20px;
	}

	.content_div .product_parameter .configure_BOX {
		margin-top: 25px;
	}

	ul {
		padding: 0;
		list-style: none;
	}

	.content_div .product_parameter .Title {
		border-bottom: 1px solid #E2E2E2;
		padding-bottom: 32px;
	}

	.content_div .product_parameter .Title .brief {
		color: #666666;
		font-size: 17px;
		display: block;
		text-align: left;
		margin-top: 5px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		margin-right: 10px
	}

	.content_div .product_parameter .Title .Title_box .money {
		color: #D03B3B;
		font-size: 30px;
		font-weight: bold;
	}

	.content_div .product_parameter .Title .Title_box .Title_text {
		color: #000000;
		font-size: 36px;
		font-weight: bold;
	}

	.content .content_top .content_div .product_parameter .Title .Title_box {
		display: flex;
		justify-content: space-between;
	}

	.content .content_top .content_div .product_img .switch_img {
		height: 86px;
		border: 1px solid #000000;
		width: 524px;
	}

	.content .content_top .content_div .product_img .product_this>img {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}

	.content .content_top .content_div .product_img .product_this {
		width: 524px;
		height: 401px;
		margin-bottom: 9px;
		text-align: left;
	}

	.content .content_top .content_div .product_parameter {
		width: 50%;
		display: flex;
		-webkit-flex-direction: column;
		flex-direction: column;
		justify-content: space-between;
	}

	.content .content_top .content_div .product_img {
		width: 50%;
	}

	.content .content_top .content_div {
		display: flex;
	}

	.content .content_top .content_div {
		max-width: 1200px;
		margin: 0 auto;
		min-width: 1200px;

	}

	.content .content_top {
		background-color: #FFFFFF;
	}

	.content .content_top .background {
		width: 100%;
		height: 60px;
		background-color: #fff;
	}

	.section-content {
		/*margin-bottom: 38px;*/
		background-color: #FFFFFF;
	}

	.Title_box-mine {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		font-size: 16px;
		color: #0c9ae2;
	}

	.price-index-items {
		display: flex;
		width: 100%;
	}

	.price-index-items>p:nth-child(1) {
		width: 30%;
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/components/goodsCenter/GoodsDetails.vue